import axiosInstance from "../../utils/axios";

const responseMessage = (data) => {
  if (typeof data === "string") return data;
  if (Array.isArray(data)) return data.filter((item) => typeof item === "string").join(" ");
  if (typeof data?.title === "string") return data.title;
  if (typeof data?.message === "string") return data.message;
  if (data?.errors && typeof data.errors === "object") {
    return Object.values(data.errors).flat().filter((item) => typeof item === "string").join(" ");
  }
  return undefined;
};

const requireSuccess = (response, fallback) => {
  if (!Number.isInteger(response?.status) || response.status < 200 || response.status >= 300) {
    throw new Error(responseMessage(response?.data) || fallback);
  }
  return response.data;
};

const requestConfig = (signal) => ({
  signal,
  timeout: 30000,
  validateStatus: () => true,
});

const getOptions = async (path, description, signal) => {
  const records = requireSuccess(await axiosInstance.get(path, requestConfig(signal)), `Unable to load ${description}.`);
  if (!Array.isArray(records)) throw new Error(`Unexpected ${description} response.`);
  return records;
};

export const getPriceCustomers = (signal) => getOptions("/Admin/customers", "customers", signal);
export const getPriceCities = (signal) => getOptions("/Settings/Cities", "cities", signal);
export const getPriceTowns = (cityId, signal) => getOptions(`/Settings/Towns/${cityId}`, "destination towns", signal);

export const calculateDeliveryFee = async (values, signal) => {
  const payload = {};
  for (const field of ["customerId", "originId", "destinationId", "townId"]) {
    const value = Number(values[field]);
    if (!Number.isInteger(value) || value <= 0 || value > 2147483647) {
      throw new Error("Please select a customer, origin city, destination city, and destination town.");
    }
    payload[field] = value;
  }
  payload.weight = Number(values.weight);
  if (!Number.isFinite(payload.weight) || payload.weight <= 0) {
    throw new Error("Enter a weight greater than zero.");
  }
  const fees = requireSuccess(
    await axiosInstance.post("/Admin/DeliveryFee", payload, requestConfig(signal)),
    "Unable to generate price. Please try again."
  );
  if (!fees || !["ServiceFee", "OnforwardingFee", "Discount", "VatAmount", "TotalAmount"].every((field) => typeof fees[field] === "number" && Number.isFinite(fees[field]))) {
    throw new Error("Unexpected price response. Please try again.");
  }
  return fees;
};
